import { hasDecimals } from '../math/has_decimals';

export const generateSetup = ( currencySetup, overrides, value) => {
    const setup = { ...currencySetup, ...overrides };

    return (
        !hasDecimals(value)
            ? { ...setup, decimalDigits: 0 }

        : setup
    );
};
